import React, { createContext, useContext, useState, useEffect } from 'react';

const PlaybackSpeedContext = createContext();

export const usePlaybackSpeed = () => {
  const context = useContext(PlaybackSpeedContext);
  if (!context) {
    throw new Error('usePlaybackSpeed must be used within a PlaybackSpeedProvider');
  }
  return context;
};

export const PlaybackSpeedProvider = ({ children }) => {
  const [speed, setSpeed] = useState(() => {
    // Load from localStorage or default to 1.0
    const saved = localStorage.getItem('ttsPlaybackSpeed');
    return saved ? parseFloat(saved) : 1.0;
  });

  useEffect(() => {
    // Save to localStorage whenever speed changes
    localStorage.setItem('ttsPlaybackSpeed', speed.toString());
  }, [speed]);

  const toggleSpeed = () => {
    // Cycle through: 0.25 -> 0.5 -> 0.75 -> 1.0 -> 0.25
    const speeds = [0.25, 0.5, 0.75, 1.0];
    const currentIndex = speeds.indexOf(speed);
    const nextIndex = (currentIndex + 1) % speeds.length;
    setSpeed(speeds[nextIndex]);
  };

  return (
    <PlaybackSpeedContext.Provider value={{ speed, toggleSpeed }}>
      {children}
    </PlaybackSpeedContext.Provider>
  );
};

